module.exports = __webpack_public_path__ + "media/images/badge/supercoppa-finalista_secondary-3346424fdaccff1d11130e649c5ffafa.png";